// Broad Color Palette
export const broadBlue = "#006DB6"
export const broadPrimary = "#006db6"
export const broadDarkPrimary = "#004c7f"

// secondary Color Palette
export const broadRed = "#B12028"
export const broadOrange = "#F36C3E"
export const broadYellow = "#FFCD00"
export const broadGreen = "#6EA239"
export const broadCyan = "#32A0C8"
export const broadPurple = "#69488E"
export const broadGray = "#63666A"

// export all colors as an object for convenience
export const colors = {
  blue: broadBlue,
  primary: broadPrimary,
  darkPrimary: broadDarkPrimary,
  red: broadRed,
  orange: broadOrange,
  yellow: broadYellow,
  green: broadGreen,
  cyan: broadCyan,
  purple: broadPurple,
  gray: broadGray,
}

export default colors
